import { render, staticRenderFns } from "./close.vue?vue&type=template&id=735e07e0&scoped=true&"
var script = {}
import style0 from "./close.vue?vue&type=style&index=0&id=735e07e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "735e07e0",
  null
  
)

export default component.exports